import EventBroker from "../../scripts/eventBroker"

export const bus = new EventBroker("schedule")